export default class AnswerStructure {
  constructor() {
    this.key = [];
    this.grid = [];
  }
}
